import { createFileRoute } from '@tanstack/react-router';

import { CalculatorTab } from '@/features/deals';

export const Route = createFileRoute('/_app/deals/$dealId/calculator')({
  component: function Tab() {
    const { dealId } = Route.useParams();
    return <CalculatorTab dealId={dealId} />;
  },
});
